import type { Editor } from 'slate'
import type { CustomEditor } from 'modules/community/types/custom-editor'

// TODO: inline
export const withMentions = (editor: Editor): CustomEditor => {
  const { isInline, isVoid } = editor

  editor.isInline = element => {
    return element.type === 'mention' ? true : isInline(element)
  }

  editor.isVoid = element => {
    return element.type === 'mention' ? true : isVoid(element)
  }

  return editor
}
